import { useFlags } from 'launchdarkly-react-client-sdk'
export function useFeatureFlags() {
    const { downtimePage, swiftid, companyAccounts, appInstall, accountNavigation } = useFlags()

    return {
        showDownTimePage: downtimePage || false,
        swiftIdIndividual: swiftid,
        showCompanyAccounts: companyAccounts || false,
        showAppInstall: appInstall || false,
        accountNavigation: accountNavigation || false, // This is a temporary flag to enable the account navigation feature for all users. It will be removed once the feature is fully rolled out.
    }
}
